import React from "react";
import {

  TextField,

} from "@mui/material";

export default function KebapPage() {
  return (
    <div>
      <TextField label="Adınız"  sx={{ marginBottom: 2 }} />

    </div>
  );
}
